<script setup>
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

const props = defineProps({
  ticket: {
    type: [Object, Array, null],
    required: true,
  },
  modelValue: {
    type: Number,
    required: true,
  }
})

const emit = defineEmits(['update:modelValue']);

function addTicket() {
  emit('update:modelValue', props.modelValue + 1);
}

function removeTicket() {
  if (props.modelValue > 0) {
    emit('update:modelValue', props.modelValue - 1);
  }
}

</script>

<template>

  <li v-if="ticket.price === 0" class="additional-service__ticket">
    <div class="additional-service__main-info">
      <div class="additional-service__name">{{ ticket.name }}</div>
      </div>
      <div class="additional-service__desc-added">{{ translator.t("main", "The service is included in the ticket price") }}</div>
      <div class="additional-service__desc">{{ ticket.view_name }}</div>
      <div class="additional-service__scheme-link" v-if="[224, 225, 226, 35, 36, 37].includes(ticket.service_id)">
      <p @click="changeShowScheme(ticket.service_id)">{{ translator.t("main", "View diagram") }}</p>
    </div>
  </li>

  <li class="additional-service__ticket" v-else>
    <div class="additional-service__main-info">
      <div class="additional-service__name">{{ ticket.name }}</div>
      <div class="additional-service__price">{{ ticket.price }} ₽</div>
    </div>
    <div class="additional-service__desc">{{ ticket.view_name }}</div>
    <div class="additional-service__scheme-link" v-if="[224, 225, 226, 35, 36, 37].includes(ticket.service_id)">
      <p @click="changeShowScheme(ticket.service_id)">{{ translator.t("main", "View diagram") }}</p>
    </div>

    <div class="additional-service__count-container">
			<div @click="removeTicket" class="additional-service__minus-service">
				<svg width="20" height="20" class="">
					<use xlink:href="#minus-service"></use>
				</svg>
			</div>
			<div class="additional-service__service-count">{{ ticket.addAdditionalTicketCount }}</div>
			<div @click="addTicket" class="additional-service__plus-service">
				<svg width="20" height="20" class="">
					<use xlink:href="#plus-service"></use>
				</svg>
			</div>
		</div>
  </li>
</template>

<style lang="scss">
  @import '../../../../styles/custom/additional-services.scss';

  .additional-service {
    &__ticket {
      min-height: 99px;
      padding: 12px 16px;
      position: relative;
      border-radius: 5px;
      border: 2px solid #E3E5EC;
      background: $white;
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      justify-content: flex-start;
      align-items: flex-start;

      &:hover {
        border: 2px solid $primary;
      }
    }

    &__price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
    }

    &:not(:last-of-type) {
      margin-bottom: 8px;
    }
  }

  .additional-service-modal {
    &__header {
      font-size: 24px;
      font-weight: 700;
      line-height: 120%;
      margin-bottom: 12px;
    }

    &__desc {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      font-size: 14px;
      font-weight: 400;
      line-height: 130%;
      color: $color;

      p {
        margin-bottom: 0;
      }
    }
  }
</style>